import { ridgeline } from './ridgeline';
import { duel } from './duel';
import { twinbridges } from './twinbridges';
import { bastions } from './bastions';
import { crossroads } from './crossroads';
import { goldbasin } from './goldbasin';
import { fourwinds } from './fourwinds';
import { pinwheel } from './pinwheel';
import { steppes } from './steppes';
import { parseMap } from './types';
import type { MapDef, ParsedMap } from './types';

export type { MapDef, ParsedMap, RotatableStarts, StartSlot } from './types';
export { parseMap, rotateQuarterCW, startRotation, tileIndex } from './types';

/*
 * מפה חדשה = קובץ חדש + שורה אחת כאן.
 *
 * ה-barrel מפורש ולא `import.meta.glob` בכוונה: כך `MapId` הוא יוניה של מזהים
 * ליטרליים, וטעות כתיב במזהה מפה נופלת בקומפילציה ולא בזמן ריצה.
 */
export const MAP_DEFS = [
    ridgeline,
    duel,
    twinbridges,
    bastions,
    crossroads,
    goldbasin,
    fourwinds,
    pinwheel,
    steppes,
] as const satisfies readonly MapDef[];

export type MapId = (typeof MAP_DEFS)[number]['id'];

const BY_ID = new Map<string, MapDef>(MAP_DEFS.map((def) => [def.id, def]));

export function getMapDef(id: MapId): MapDef {
    const def = BY_ID.get(id);
    if (!def) throw new Error(`מפה לא מוכרת: ${id}`);
    return def;
}

/*
 * הפענוח יקר יחסית (9,216 אריחים) וחוזר על עצמו בכל פתיחת משחק ובכל טסט,
 * ולכן נשמר במטמון. התוצאה נחשבת קפואה — אף אחד לא כותב לתוך המערכים האלה;
 * מצב המשחק מחזיק עותק משלו של שכבת העפרות, שמשתנה במהלך המשחק.
 */
const parsed = new Map<string, ParsedMap>();

export function getMap(id: MapId): ParsedMap {
    const cached = parsed.get(id);
    if (cached) return cached;
    const result = parseMap(getMapDef(id));
    parsed.set(id, result);
    return result;
}

export const DEFAULT_MAP_ID: MapId = 'ridgeline';
